<script setup lang="ts">

import { computed } from 'vue';
import { currency } from '@library/Utilities';
import { categories } from '../Types/Categories';

import ProductFeaturesOption from '../Components/ProductFeaturesOption.vue';
import ScaleContainer from '../Components/ScaleContainer.vue';

type Props = {
    category: number,
    currentCategory: number
}

const props = defineProps<Props>();
const selectedCategory = computed( () => categories[ props.currentCategory - 1 ] );

const benefit = computed( () => 
    selectedCategory.value.left.reduce( (a,v) => a += v.amount, 0 ) + 
    selectedCategory.value.right.reduce( (a,v) => a += v.amount, 0 )
);

</script>

<template>

    <div class="p-8 w-full tracking-wider flex justify-center items-center">

        <div class="w-full max-w-[90vw] flex flex-col items-center">
        
            <h2 class="text-2xl 3xl:text-3xl text-white font-semibold">
                Here's What You Get!
            </h2>

            <ScaleContainer 
                :slot-width="1300" 
                class="mt-6 3xl:mt-14 text-center">
                
                <div class="grid grid-cols-11 items-center">
                    <div class="col-span-4">
                        <ProductFeaturesOption 
                            v-for="option in selectedCategory.left" 
                            :option="option" 
                            flip 
                        />
                    </div>

                    <div class="col-span-3">
                        <img src="@/assets/images/Products/car.png" class="w-full scale-125" />
                    </div>

                    <div class="col-span-4">
                        <ProductFeaturesOption 
                            v-for="option in selectedCategory.right" 
                            :option="option" 
                        />
                    </div>
                </div>

                <table class="text-lg 3xl:text-xl font-bold mt-4 3xl:mt-16 w-[520px] mx-auto uppercase text-left rounded-lg overflow-hidden">
                    <tbody>
                        <tr>
                            <td class="italic p-2 border-t border-white/10">
                                Protect Price
                            </td>
                            <td class="font-semibold text-white text-right p-2 border-t border-white/10">
                                {{ currency( selectedCategory.rrp, '$', false ) }}
                            </td>
                        </tr>
                        <tr>
                            <td class="italic p-2 border-t border-white/10">
                                Term
                            </td>
                            <td class="font-semibold text-white text-right p-2 border-t border-white/10">
                                3 years
                            </td>
                        </tr>
                        <tr class="text-amber-400 bg-amber-100/10">
                            <td class="italic p-2 border-t border-white/10">
                                Your total benefit
                            </td>
                            <td class="font-bold text-right p-2 border-t border-white/10">
                                {{ currency( benefit, '$', false ) }}
                            </td>
                        </tr>
                        <tr class="text-indigo-400 text-sm text-center font-semibold">
                            <td colspan="2"
                                class="px-2 pt-2 border-t border-white/10">
                                Saves you up to 
                                <span class="text-indigo-300">{{ currency( benefit - selectedCategory.rrp, '$', false ) }}</span>
                                on your car's perishable parts
                            </td>
                        </tr>
                    </tbody>
                </table>

            </ScaleContainer>
        
            <div>
                <a href="https://carparc.carbucks.com.au/carparc/vehicle/create?p=kyc&vp=details" target="_blank">
                    <Button 
                        variant="flat"
                        size="x-large"
                        color="#0CACF2"
                        class="mt-12 bg-gradient-to-r from-cyan-500 via-indigo-500 to-purple-600 ring ring-indigo-400/70">
                        Get Your Wear &amp; Tear Protection
                    </Button>
                </a>
            </div>
        </div>

    </div>


</template>